'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

const sitemapSections = [
  {
    title: 'Main Pages',
    links: [
      { label: 'Home', href: '/' },
      { label: 'About Us', href: '/about' },
      { label: 'Contact', href: '/contact' },
      { label: 'Guides', href: '/guides' },
    ],
  },
  {
    title: 'Shop',
    links: [
      { label: 'Home Printers', href: '/home-printers' },
      { label: 'Office Printers', href: '/office-printers' },
      { label: 'Inkjet Printers', href: '/inkjet-printers' },
      { label: 'Cart', href: '/cart' },
    ],
  },
  {
    title: 'Legal & Policies',
    links: [
      { label: 'Privacy Policy', href: '/privacy-policy' },
      { label: 'Terms & Conditions', href: '/terms-and-conditions' },
      { label: 'Refund & Return Policy', href: '/refund-and-return' },
      { label: 'Shipping Policy', href: '/shipping-policy' },
      { label: 'Purchase Policy', href: '/purchase-policy' },
      { label: 'Disclaimer', href: '/disclaimer' },
      { label: 'Accessibility', href: '/accessibility' },
    ],
  },
];

export default function SitemapPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-4xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Sitemap</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Sitemap</h1>
            <p className="mt-3 text-slate-300">A complete overview of all pages on RePrint Solution.</p>
          </div>
        </section>

        <section className="py-14">
          <div className="container mx-auto max-w-4xl px-4">
            <div className="grid gap-8 sm:grid-cols-3">
              {sitemapSections?.map((section) => (
                <div key={section?.title} className="rounded-xl border border-white/10 bg-white/[0.04] p-6">
                  <h2 className="text-xs font-black uppercase tracking-widest text-violet-300">{section?.title}</h2>
                  <ul className="mt-4 space-y-2.5">
                    {section?.links?.map((link) => (
                      <li key={link?.href}>
                        <Link href={link?.href} className="text-sm text-slate-300 transition hover:text-white">
                          → {link?.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
